<nav class="flex gap-1 justify-center">
  @for (tab of tabs; track tab) {
    <a
      class="blu-tab-item flex-1"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLink="/sign-in/{{ tab.path }}"
    >
      {{ tab.label }}
    </a>
  }
</nav>

<router-outlet></router-outlet>
